import { CustomButton, CustomTextField, HeaderFilterBox } from '../../../../common/components';

const DifferimentInvoicesFilters = ({
  filters,
  onChange,
  onFetch,
  isFetching,
}) => {
  return (
    <HeaderFilterBox>
      <CustomTextField
        label="Desde"
        type="date"
        size="medium"
        value={filters.startDate}
        onChange={(e) => onChange('startDate', e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={{ maxWidth: { xs: '100%', md: 200 }, mr: 1.5, mt: 0 }}
      />
      <CustomTextField
        label="Hasta"
        type="date"
        size="medium"
        value={filters.endDate}
        onChange={(e) => onChange('endDate', e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={{ maxWidth: { xs: '100%', md: 200 }, mr: 1.5, mt: 0 }}
      />
      <CustomTextField
        label="Contrato"
        placeholder="Ej: 12"
        value={filters.contractNumber}
        onChange={(e) => onChange('contractNumber', e.target.value)}
        size="medium"
        sx={{ maxWidth: { xs: '100%', md: 200 }, mr: 1.5, mt: 0 }}
      />
      <CustomButton onClick={onFetch} disabled={isFetching} variant="base">
        Consultar
      </CustomButton>
    </HeaderFilterBox>
  );
};

export default DifferimentInvoicesFilters;
